import { render, staticRenderFns } from "./ThemesEditorSidebar.vue?vue&type=template&id=4b96665c"
import script from "./ThemesEditorSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./ThemesEditorSidebar.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports